/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2359
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.BindingCount = {
  MultipleBindingsAvailable: 2,
  NoBindingsAvailable: 0,
  OnlyOneBindingAvailable: 1
}
